import { render } from "./CustomMessage.vue?vue&type=template&id=4ccbf039&scoped=true"
import script from "./CustomMessage.vue?vue&type=script&lang=js"
export * from "./CustomMessage.vue?vue&type=script&lang=js"

import "./CustomMessage.vue?vue&type=style&index=0&id=4ccbf039&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ccbf039"

export default script